const host = window.location.hostname;

const configs = {
  localhost: {
    apiUrl: "http://localhost:5540/",
    authAppUrl: "http://localhost:9292",
    assetsUrl: "http://localhost:5003",
    authHostsPattern: "localhost",
    name: "development",
  },
  "app.assets.quiteja.staging.gorillascode.com": {
    apiUrl: "https://api.assets.quiteja.staging.gorillascode.com/",
    assetsUrl: "https://app.assets.quiteja.staging.gorillascode.com",
    authAppUrl: "https://auth.staging.gorillascode.com",
    authHostsPattern: ".quiteja.staging.gorillascode.com",
    name: "staging",
  },
  "app.assets.quiteja.com.br": {
    apiUrl: "https://api.assets.quiteja.com.br/",
    assetsUrl: "https://app.assets.quiteja.com.br",
    authAppUrl: "https://auth.quiteja.com.br",
    authHostsPattern: ".quiteja.com.br",
    name: "production",
  },
};

if (!Object.keys(configs).includes(host)) {
  configs[host] = {
    apiUrl: `http://${host}:5540/`,
    authAppUrl: `http://${host}:9292`,
    assetsUrl: `http://${host}:5003`,
    authHostsPattern: host,
    name: "development",
  };
}

let env;
if (host.includes("pr-")) {
  env = {
    apiUrl: "https://api.assets.quiteja.staging.gorillascode.com/",
    assetsUrl: "https://app.assets.quiteja.staging.gorillascode.com",
    authAppUrl: "https://auth.staging.gorillascode.com",
    authHostsPattern: ".quiteja.staging.gorillascode.com",
    name: "staging",
  };
} else {
  env = {
    configs,
    apiUrl: configs[host].apiUrl,
    authAppUrl: configs[host].authAppUrl,
    assetsUrl: configs[host].assetsUrl,
    authHostsPattern: configs[host].authHostsPattern,
    name: configs[host].name,
  };
}

export default env;
